import { useEffect, useState } from "react";
import UserDelete from "./UserDelete";
import EditUser from "./EditUser";
import PasswordResetM from "./PasswordResetM";
import ResetPasswordModal from "./ResetPasswordModal";
import UnlockUserModal from "./UnlockUserModal";
import userSettings from "../../src/assets/Schedule/useredit.svg";
import ConfigModal from "./ConfigModal";
import { useNavigate } from "react-router-dom";
import EmployeePhotoModal from "../facialrecognization/views/employeephotomodal";
import api from "../api/api";
import { preferRouteUrls } from "../api/patientFiles";
import { Backdrop, CircularProgress } from "@mui/material";
import StatusChangeModal from "./statusconformation";
import { getPracticeId, staffFaceEnrol } from "../config/practice";
import {
  CameraGlyph,
  CheckGlyph,
  KeyGlyph,
  MailGlyph,
  PencilGlyph,
  SortArrowGlyph,
  TrashGlyph,
  initialsOf,
  lastActive,
  roleClass,
  statusOf,
} from "./userui";
import { departmentLabel, userDepartment } from "./userDepartments";
import "./user.css";
const UsersTable = ({ users, sortOrder,sortColumn,
  setSortColumn,
  lastActiveSort,
  setLastActiveSort,changestatus,setSortOrder,fetchUsersData, imagesdata, onFileChange,
  deptEnabled = false, deptById = {}, deptOptions = [] }) => {
  const [loading, setLoading] = useState(false);
  const practiseid = getPracticeId();
  const [userDelete, setUserDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [userEdit, setUserEdit] = useState(false);
  const [PasswordReset, setPasswordReset] = useState(false);
  const [providerConfigModal, setproviderConfigModal] = useState(false);
  const [providerConfig, setproviderConfig] = useState(null);
  const [resetData, setResetData] = useState(null);
  const [passwordUser, setPasswordUser] = useState(null);
  const [unlockUser, setUnlockUser] = useState(null);
  const [selectedimg, setSelectedimg] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [photoloading, setPhotoLoading] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
const [selectedStatusUser, setSelectedStatusUser] = useState(null);

  const navigate = useNavigate();
  const DeleteModalClose = () => {
    setUserDelete(false);
  };

  const CloseEditUser = () => {
    setUserEdit(false);
    setSelectedimg("");
  };

  const CloseResendModal = () => {
    setPasswordReset(false);
  };

  const handelDeleteUser = (userId) => {
    setSelectedRow(userId);
    setUserDelete(true); // Open the modal
  };

  const handelEditUser = (userId) => {
    setSelectedRow(userId);

    const matchedImage = imagesdata.find((img) => img.rowid === userId?.id);

    if (matchedImage) {
      setSelectedimg(matchedImage);
    }
    setUserEdit(true); // Open the modal
  };
  const handelResendModal = (userId) => {
    setSelectedRow(userId.id);
    setResetData(userId);
    setPasswordReset(true); // Open the modal
  };
  const handleProviderConfig = (item) => {
    console.log("Opening modal with config:", item);
    setproviderConfigModal(true);
    setproviderConfig(item);
  };
  const handlecloseConfig = () => {
    setproviderConfigModal(false);
  };
  useEffect(() => {
    const matchedImage = imagesdata.find(
      (img) => img.rowid === selectedRow?.id
    );

    if (matchedImage) {
      setSelectedimg(matchedImage);
    }
  }, [users]);
  const handleViewPhotos = async (id) => {
    try {
      setPhotoLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/onboarding-employee/${id}`
      );
      if (response.status === 200) {
        // the authenticated route URLs when the API sends them (signed links expire)
        setSelectedImages(preferRouteUrls(response.data.employee_image_urls, response.data.employee_images || []));
        setOpenModal(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPhotoLoading(false);
    }
  };

  const faceEnrol = staffFaceEnrol();
  const columnCount = 6 + (faceEnrol ? 1 : 0) + (deptEnabled ? 1 : 0);

  return (
    <div className="bmus-card">
      <div className="bmus-scroll">
        <table className="bmus-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>User ID</th>
              <th>Role</th>
              {deptEnabled && <th>Department</th>}
              <th>
                <button
                  type="button"
                  className={`bmus-sort${sortColumn === "last_active" ? " on" : ""} ${lastActiveSort}`}
                  onClick={() => {
                    setSortColumn("last_active");
                    setLastActiveSort(lastActiveSort === "asc" ? "desc" : "asc");
                  }}
                >
                  Last active {SortArrowGlyph}
                </button>
              </th>
              <th>
                <button
                  type="button"
                  className={`bmus-sort${sortColumn === "status" ? " on" : ""} ${sortOrder}`}
                  onClick={() => {
                    setSortColumn("status");
                    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                  }}
                >
                  Status {SortArrowGlyph}
                </button>
              </th>
              {faceEnrol && <th>Face ID</th>}
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="bmus-empty" colSpan={columnCount}>Loading…</td>
              </tr>
            ) : users.length === 0 ? (
              <tr>
                <td className="bmus-empty" colSpan={columnCount}>No users match this view.</td>
              </tr>
            ) : (
              users.map((item, index) => {
                const matchedImage = imagesdata.find((img) => img.rowid === item.id);
                const state = statusOf(item);
                const when = lastActive(item.last_login);
                const enrolled = item?.config?.enrolled_id;
                // rolename comes off the roles relationship; a row whose grole
                // was never set still has its own free-text role column.
                const roleText = String(item.rolename || item.role || "").trim();
                return (
                  <tr key={index}>
                    <td>
                      <div className="bmus-who">
                        <span className="bmus-avatar">
                          {matchedImage ? (
                            <img src={`data:image/jpeg;base64,${matchedImage.image}`} alt="" />
                          ) : (
                            initialsOf(item)
                          )}
                          {state === "Active" && <span className="bmus-online" aria-hidden="true" />}
                        </span>
                        <span className="bmus-name">
                          <b>{`${item.firstname || ""} ${item.lastname || ""}`.trim()}</b>
                          <span title={item.email}>{item.email}</span>
                        </span>
                      </div>
                    </td>
                    <td><span className="bmus-uid">{item.username}</span></td>
                    <td>
                      {roleText ? (
                        <span className={`bmus-role ${roleClass(roleText)}`}>{roleText}</span>
                      ) : (
                        <span className="bmus-when none">—</span>
                      )}
                    </td>
                    {deptEnabled && (() => {
                      const dept = userDepartment(deptById, item);
                      const untagged = dept?.state === "untagged";
                      return (
                        <td data-testid={`user-dept-${item.id}`}>
                          <span className={`bmus-when${untagged ? " none" : ""}`} style={untagged ? { color: "#C2410C" } : undefined}>
                            {departmentLabel(dept) || "-"}
                          </span>
                        </td>
                      );
                    })()}
                    <td>
                      <span className={`bmus-when${when.none ? " none" : ""}`} title={when.title}>
                        {when.text}
                      </span>
                    </td>
                    <td>
                      {/* Locked opens Unlock; Active / Inactive open the
                          confirmation they always did. */}
                      <button
                        type="button"
                        className={`bmus-status ${state.toLowerCase()}`}
                        title={state === "Locked" ? "Unlock this user" : undefined}
                        onClick={() => {
                          if (state === "Locked") {
                            setUnlockUser(item);
                            return;
                          }
                          setSelectedStatusUser(item);
                          setStatusModalOpen(true);
                        }}
                      >
                        <span className="dot" aria-hidden="true" />
                        {state}
                      </button>
                    </td>
                    {faceEnrol && (
                      <td>
                        {enrolled ? (
                          <button
                            type="button"
                            className="bmus-face on"
                            title="View enrolled photos"
                            onClick={() => handleViewPhotos(enrolled)}
                          >
                            {CheckGlyph} Enrolled
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="bmus-face off"
                            title="Enrol this user's face"
                            onClick={() =>
                              navigate(
                                `/onboard-emp?userid=${item.id}&username=${item.username}&email=${item.email}&phone=${item.phone}`
                              )
                            }
                          >
                            {CameraGlyph} Enroll
                          </button>
                        )}
                      </td>
                    )}
                    <td>
                      <div className="bmus-acts">
                        {item.providerid ? (
                          <button
                            type="button"
                            className="bmus-act"
                            onClick={() => handleProviderConfig(item)}
                            title="Provider configuration"
                            aria-label="Provider configuration"
                          >
                            <img src={userSettings} alt="" />
                          </button>
                        ) : null}
                        {/* Resend welcome: C-HIM's staff enrolment (9928; OSA's
                            build hid it). */}
                        {faceEnrol && (
                          <button
                            type="button"
                            className="bmus-act"
                            onClick={() => handelResendModal(item)}
                            title="Resend welcome email"
                            aria-label="Resend welcome email"
                          >
                            {MailGlyph}
                          </button>
                        )}
                        <button
                          type="button"
                          className="bmus-act"
                          onClick={() => setPasswordUser(item)}
                          title="Reset password"
                          aria-label="Reset password"
                        >
                          {KeyGlyph}
                        </button>
                        <button
                          type="button"
                          className="bmus-act"
                          onClick={() => handelEditUser(item)}
                          title="Edit user"
                          aria-label="Edit user"
                        >
                          {PencilGlyph}
                        </button>
                        <button
                          type="button"
                          className="bmus-act"
                          onClick={() => handelDeleteUser(item)}
                          title="Delete user"
                          aria-label="Delete user"
                        >
                          {TrashGlyph}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      <EmployeePhotoModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        images={selectedImages}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
        }}
        open={photoloading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {userDelete && (
        <UserDelete
          fetchUsersData={fetchUsersData}
          DeleteModalClose={DeleteModalClose}
          userrowId={selectedRow}
        />
      )}
      {userEdit && (
        <EditUser
          onFileChange={onFileChange}
          img={selectedimg.image}
          fetchUsersData={fetchUsersData}
          CloseEditUser={CloseEditUser}
          userrow={selectedRow}
          deptEnabled={deptEnabled}
          department={userDepartment(deptById, selectedRow)}
          deptOptions={deptOptions}
        />
      )}
      {unlockUser && (
        <UnlockUserModal user={unlockUser} onClose={() => setUnlockUser(null)} onUnlocked={fetchUsersData} />
      )}
      {passwordUser && (
        <ResetPasswordModal user={passwordUser} onClose={() => setPasswordUser(null)} />
      )}
      {PasswordReset && (
        <PasswordResetM
          CloseResendModal={CloseResendModal}
          userData={resetData}
        />
      )}
      {statusModalOpen && (
  <StatusChangeModal
    user={selectedStatusUser}
    onClose={() => setStatusModalOpen(false)}
    onConfirm={(user)=>{
changestatus(user)
setStatusModalOpen(false)
    }}
  />
)}

      {providerConfigModal && (
        <ConfigModal
          handlecloseConfig={handlecloseConfig}
          providerConfig={providerConfig}
        />
      )}
    </div>
  );
};

export default UsersTable;
